export const LOCALE_TYPE = {
  /** 日本語(基本言語) */
  JA: 'ja',
  /** 英語 */
  EN: 'en',
  /** 繫体中国語 */
  ZH_HANT: 'zh-Hant',
} as const;
